import ContactsController from "@/controllers/ContactsController";
import SprController from "@/controllers/SprController";

const mapData = (data = [], type = 'founder') => {
  const [Promise1, Promise2] = data;
  const value1 = Promise1.value;
  const value2 = Promise2.value;
  const mappedData = value1.map(el => ({...el, contact: []}));
  value2?.forEach(el => {
    const contactSplice = mappedData.find(el2 => el2.id === el[type]?.id);
    if (contactSplice)
      contactSplice.contact.push(el);
  })
  return mappedData
}
export default {
  namespaced: true,
  state: {
    founders: [],
    foundersLoading: false,
    cos: [],//центры ответственности
    cosLoading: false,
    regions: [],
    regionsLoading: false,
    kcpGroups: [],
    kcpGroupsLoading: false,
    usls: [],
    uslsLoading: false,
    fo: [],
    foLoading: false,
    spec: [],
    specLoading: false,
    orgs: [],
    orgsLoading: false,
    orgsByOwner: [],
    orgsByOwnerLoading: false,
    indicators: [],
    indicatorsLoading: false,
    kcpUgs: [],
    kcpUgsLoading: false,
    types: [],
    typesLoading: false,
    chosenOrg: null,
  },
  mutations: {
    ['LOADING_STATUS'](state, payload) {
      state[payload.name + 'Loading'] = payload.value;
    },
    ['CHANGE_VALUE'](state, payload) {
      state[payload.name] = payload.value;
    },
    ['CHANGE_BLOCK_VALUE'](state, payload) {
      const item = state[payload.name + 's'].find(el => el.id === payload[payload.name].id)?.stageDataBlocks;
      if (item) {
        const blockIndex = item.findIndex(el => el.stageId === payload.stageId);
        if (blockIndex === -1)
          item.push(payload);
        else
          item[blockIndex].block = payload.block
      }
    },
  },
  actions: {
    async getCOsFromServer({commit, state}) {
      try {
        if (state.foundersLoading)
          return;
        commit('LOADING_STATUS', {name: 'cos', value: true});
        if (state.cos.length > 0) {
          commit('LOADING_STATUS', {name: 'cos', value: false});
          return;
        }
        await Promise.allSettled([SprController.getCOsOrRegionsInfo('founder'), ContactsController.getAllContactsController('founder')])
          .then(data => {
            commit('CHANGE_VALUE', {name: 'cos', value: mapData(data)})
          })
          .catch(e => console.error(e))
          .finally(() => commit('LOADING_STATUS', {name: 'cos', value: false}));

      } catch (e) {
        commit('LOADING_STATUS', {name: 'cos', value: false});
      }
    },
    async getRegionsFromServer({commit, state}) {
      try {
        if (state.regionsLoading)
          return;
        commit('LOADING_STATUS', {name: 'regions', value: true});
        if (state.regions.length > 0) {
          commit('LOADING_STATUS', {name: 'regions', value: false});
          return;
        }
        await Promise.allSettled([SprController.getCOsOrRegionsInfo('region'), ContactsController.getContactsFiles('region')])
          .then(data => {
            commit('CHANGE_VALUE', {name: 'regions', value: mapData(data, 'region')})
          })
          .catch(e => console.error(e))
          .finally(() => commit('LOADING_STATUS', {name: 'regions', value: false}))
      } catch (e) {
        commit('LOADING_STATUS', {name: 'regions', value: false});
      }
    },
    async getKcpGroupsFromServer({commit, state}) {
      try {
        if (state.kcpGroupsLoading)
          return;
        commit('LOADING_STATUS', {name: 'kcpGroups', value: true});
        if (state.kcpGroups.length > 0) {
          commit('LOADING_STATUS', {name: 'kcpGroups', value: false});
          return;
        }
        await SprController.getKcpGroups()
          .then(data => {
            commit('CHANGE_VALUE', {name: 'kcpGroups', value: data})
          })
          .catch(e => console.error(e))
          .finally(() => commit('LOADING_STATUS', {name: 'kcpGroups', value: false}))
      } catch (e) {
        commit('LOADING_STATUS', {name: 'kcpGroups', value: false});
      }
    },
    getSprForOrganization({commit, state}) {
      const names = ['usls', 'fo', 'spec', 'indicators', 'kcpUgs', 'types'].filter(el => {
        const res = state[el].length === 0;
        if (res)
          commit('LOADING_STATUS', {name: el, value: true})
        return res
      });
      SprController.getSprForOrganization(names).then(r => {
        r.forEach(el => {
          commit('CHANGE_VALUE', {name: el.name, value: el.value})
        });
      }).finally(() => names.forEach(el => commit('LOADING_STATUS', {name: el, value: false})))
    },
    getSprUsls({commit, state}) {
      const names = ['usls'].filter(el => {
        if (state[el + 'Loading'])
          return false;
        const res = state[el].length === 0;
        if (res)
          commit('LOADING_STATUS', {name: el, value: true})
        return res
      });
      SprController.getSprForOrganization(names).then(r => {
        r.forEach(el => {
          commit('CHANGE_VALUE', {name: el.name, value: el.value})
        });
      }).finally(() => names.forEach(el => commit('LOADING_STATUS', {name: el, value: false})))
    },
    getAllOrganizations({commit, state}) {
      const names = ['orgs', 'founders'].filter(el => {
        const res = state[el].length === 0;
        if (res)
          commit('LOADING_STATUS', {name: el, value: true})
        return res
      });
      SprController.getSprForOrganization(names).then(r => {
        r.forEach(el => {
          commit('CHANGE_VALUE', {name: el.name, value: el.value})
        });
      }).finally(() => names.forEach(el => commit('LOADING_STATUS', {name: el, value: false})))
    },
    getOrgByOwner({commit}, orgId) {
      commit('LOADING_STATUS', {name: 'orgsByOwner', value: true})
      SprController.getSprByOwnerId(orgId).then((r) => commit('CHANGE_VALUE', {
        name: 'orgsByOwner',
        value: r
      })).finally(() => commit('LOADING_STATUS', {name: 'orgsByOwner', value: false}))
    },
    changeBlockInfo({commit}, payload) {
      if (!Object.prototype.hasOwnProperty.call(payload, 'name'))
        return;
      commit('CHANGE_BLOCK_VALUE', payload);
    },
    changeSelectedOrg({commit}, payload) {
      console.log(payload);
      commit('CHANGE_VALUE', {name: 'chosenOrg', value: payload});
    }
  },
  getters: {
    getFounders: state => {
      return state.founders;
    },
    getFoundersStatus: state => {
      return state.foundersLoading;
    },
    getCos: state => {
      return state.cos;
    },
    getRegions: state => {
      return state.regions;
    },
    getRegionsStatus: state => {
      return state.regionsLoading;
    },
    getOrgs: state => state.orgs.filter(el => el.id === el.ownerId),
    getOrgsAll: state => state.orgs,
    getOrgsStatus: state => state.orgsLoading,
    getSpec: state => state.spec,
    getSpecStatus: state => state.specLoading,
    getUsls: state => state.usls,
    getUslsStatus: state => state.uslsLoading,
    getIndicators: state => state.indicators,
    getIndicatorsStatus: state => state.indicatorsLoading,
    getKcpUgs: state => state.kcpUgs,
    getKcpUgsStatus: state => state.kcpUgsLoading,
    getTypes: state => state.types,
    getTypesStatus: state => state.typesLoading,
    getAvailableOrgs: (state) => {
      return state.orgsByOwner.sort((a, b) => a?.orgOrder - b?.orgOrder)
    },
    getChosenOrgId: (state) => {
      return state.chosenOrg.id
    },
    getAvailableOrgsStatus: (state) => {
      return state.orgsByOwnerLoading
    },
    getMainOrg: (state) => {
      return state.orgsByOwner.find(el => el.ownerId === el.id)
    },
    getKcpGroups: (state, _, __, rootGetters) => {
      const id = rootGetters['keycloak/getAuthData']?.founderID ?? rootGetters['keycloak/getFakeUser']?.id;
      const ugsList = state.cos.find(el => el?.id === id)?.coUgsList;
      const ugsListIds = ugsList?.map(el => el.ugsId);
      return state.kcpGroups.filter(el => ugsListIds?.includes(el.ugs?.id) || !id).map(el => {
        return {...el, isMain: ugsList?.find(el2 => el2.ugsId === el?.ugs?.id)?.isMain ?? false}
      });
    },
    getKcpGroupsOrg: (state,) => {
      return state.kcpGroups;
    },
    getKcpGroupsStatus: state => {
      return state.kcpGroupsLoading;
    },
  }
}